import React from "react";

const BookDownloadSection = ({ book, t, getDownloadUrl }) => {
  if (!book.pdfUrl && !book.epubUrl) return null;

  return (
    <div className="download-bar">
      <div className="section-title">{t("download-as")}:</div>
      <div className="download-links">
        {book.pdfUrl && (
          <a
            href={getDownloadUrl(book.code, "pdf")}
            className="btn btn-outline-primary d-inline-flex align-items-center gap-2"
            target="_blank"
            rel="noopener"
          >
            <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
            <span>Pdf</span>
          </a>
        )}
        {book.epubUrl && (
          <a
            href={getDownloadUrl(book.code, "epub")}
            className="btn btn-outline-primary d-inline-flex align-items-center gap-2"
            target="_blank"
            rel="noopener"
          >
            <i className="fa fa-book" aria-hidden="true"></i>
            <span>ePub</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default BookDownloadSection;
